import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import healthCheckReducer from './reducers';

const importHealthCheckRoutes = () => import(/* webpackChunkName: "health-check" */ './containers/HealthCheckContainer');

const HealthCheckRoutes = ({ match }) => (
  <SentryBoundary owner={sentryConstants.TEAMS.WEB_PLATFORM}>
    <BundleRoute
      load={importHealthCheckRoutes}
      path={match.url}
    />
  </SentryBoundary>
);

HealthCheckRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.healthCheck', attachReducer(healthCheckReducer),
)(HealthCheckRoutes);
